import { CONSENT_CHANGED_EVENT } from './consent'
import { ANALYTICS_READY_EVENT } from '../lib/gtag'

// Opt-in catalog measurement: report only cards intersecting the viewport.
// A blocked event is not marked as measured, so consent granted while the
// card is still visible can produce its first permitted impression.
export const observeVisibleCatalogItems = ({ root, onVisible, measured = new Set(), windowObject = window }) => {
  const Observer = windowObject.IntersectionObserver
  if (!root || !Observer) return () => {}
  const visible = new Set()
  const report = () => {
    const pending = [...visible].filter(id => !measured.has(id))
    if (pending.length && onVisible(pending) === true) {
      pending.forEach(id => measured.add(id))
    }
  }
  const observer = new Observer(entries => {
    entries.forEach(entry => {
      const id = entry.target.dataset.catalogProductId
      if (entry.isIntersecting && entry.intersectionRatio >= 0.1) visible.add(id)
      else visible.delete(id)
    })
    report()
  }, { threshold: [0, 0.1] })
  root.querySelectorAll('[data-catalog-product-id]').forEach(element => observer.observe(element))
  windowObject.addEventListener(CONSENT_CHANGED_EVENT, report)
  windowObject.addEventListener(ANALYTICS_READY_EVENT, report)
  return () => {
    observer.disconnect()
    windowObject.removeEventListener(CONSENT_CHANGED_EVENT, report)
    windowObject.removeEventListener(ANALYTICS_READY_EVENT, report)
  }
}
